export enum SalaryComponentCalculation {
  /** K výpočtu hrubé mzdy */
  GrossWork = "GrossWork",
  /** K výpočtu odměn hrubé mzdy */
  GrossExtra = "GrossExtra",
  /** K výpočtu čisté mzdy */
  Net = "Net",
  /** K výpočtu částky k vyplacení */
  Payable = "Payable",
}
